import React, { useEffect, useState } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { useLocaleOptional } from '@/contexts/LocaleContext';
import { LanguageAnnouncementModal } from './LanguageAnnouncementModal';

const STORAGE_KEY = 'language_announcement_seen';

export const LanguageAnnouncementProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { user } = useAuth();
  const localeContext = useLocaleOptional();
  const language = localeContext?.language;
  const isLoading = localeContext?.isLoading ?? true;
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    // Wait for auth and locale to be ready
    if (!user || isLoading) return;

    // Don't show if user is already using Portuguese
    if (language === 'pt-BR') return;

    // Don't show if user has already seen the announcement
    const hasSeenAnnouncement = localStorage.getItem(STORAGE_KEY);
    if (hasSeenAnnouncement) return;

    // Show the modal
    setShowModal(true);
  }, [user, language, isLoading]);

  const handleClose = () => {
    localStorage.setItem(STORAGE_KEY, 'true');
    setShowModal(false);
  };

  return (
    <>
      {children}
      <LanguageAnnouncementModal open={showModal} onClose={handleClose} />
    </>
  );
};
